// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetPipClaim,
    updateOwnershipStatusDropDown,
    updatePipClaimFailureDate,
    updatePipClaimFailurePart,
    updatePipClaimInputOnBlur,
    updatePipClaimPin,
    updatePipClaimRepairDate,
    updatePipClaimRepairNumber,
    updatePipClaimUnitDropDown,
    updatePipClaimUseAmount,
    updatePipClaimWorkOrderOne,
    updatePipClaimWorkOrderTwo,
    updatePipProgram,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility,
    validatePipNumber
} from './claim-details';
import {
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updatePipClaimBasisForSettlement,
    updatePipClaimComplaintCause,
    updatePipClaimComplaintCorrection,
    updatePipClaimDtacCase,
    updatePipClaimDtacSolution,
    updatePipClaimFailedArea,
    updatePipClaimFailedModeComments,
    updatePipClaimOperatorComments,
    updatePipClaimOperatorsComplaint,
    updatePipClaimPartSerialNumber
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createPipClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {readPipClaim} from './get-pip-claim';
import {readPipDetails} from './get-pip-details';
import {readPipProducts} from './get-pip-products';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetClaimAndProductDetails} from './reset-claim-and-product-details';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {resetPipDetails} from './reset-pip-details';
import {resetProductDetails} from './reset-product-details';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateClaimIsNonTracked} from './update-claim-is-non-tracked';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updatePipDetails} from './update-pip-details';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createPipClaim,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    readPipClaim,
    readPipDetails,
    readPipProducts,
    resetCkcCustomerFailure,
    resetClaimAndProductDetails,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetPipClaim,
    resetPipDetails,
    resetProductDetails,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimIsNonTracked,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updatePipClaimBasisForSettlement,
    updatePipClaimComplaintCause,
    updatePipClaimComplaintCorrection,
    updatePipClaimDtacCase,
    updatePipClaimDtacSolution,
    updatePipClaimFailedArea,
    updatePipClaimFailedModeComments,
    updatePipClaimFailureDate,
    updatePipClaimFailurePart,
    updatePipClaimInputOnBlur,
    updatePipClaimOperatorComments,
    updatePipClaimOperatorsComplaint,
    updatePipClaimPartSerialNumber,
    updatePipClaimPin,
    updatePipClaimRepairDate,
    updatePipClaimRepairNumber,
    updatePipClaimUnitDropDown,
    updatePipClaimUseAmount,
    updatePipClaimWorkOrderOne,
    updatePipClaimWorkOrderTwo,
    updatePipDetails,
    updatePipProgram,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties,
    validatePipNumber
};



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/index.js